module.exports = __webpack_public_path__ + "static/img/risk.3d9d904b.svg";